import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import {Headers, RequestOptions} from '@angular/http';
//import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { UtilsService } from '../../shared/utils-service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-template-upload',
  templateUrl: './template-upload.component.html',
  styleUrls: ['./template-upload.component.css']
})
export class TemplateUploadComponent implements OnInit {
	private loader: boolean= false;
	//private url: string = this.utils.url+"/ddmfBulkEnquiry/massSearchCustomers";
	private url: string = this.utils.url+"/ddmfBulkEnquiry/massSearchCustomers";
	private uploadFile : File;
	private dataJson: any = {};
	private loggedInUser: any = {};
	// fileInpBox: any;
  	constructor(private http: Http, private router: Router, private matSnackBar: MatSnackBar, private utils: UtilsService) { 
  		this.loggedInUser = this.utils._checkSession({'page': 'mass-search-customers'});
  	}

   @ViewChild('fileInput') inputFile: any;
   @ViewChild('fileInpBox') fileInpBox: any;
   
  ngOnInit() {
  }

	onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
    if(event.target.files[0].size<=104857600){
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      //console.log(file);
      this.uploadFile = file;
      }
      else{
      	this.utils.notify('File size is invalid. Please upload file size below 100MB.');
      }
    }
  }
  
  templateUpload= function () {
		// console.log('in here');
		// console.log(this.uploadFile);	
		// console.log('in here');
		// console.log(this.uploadFile);
		 if (this.uploadFile) {
		let formData = new FormData();
		formData.append('file', this.uploadFile);
		formData.append('userId', this.loggedInUser.userId);
		// console.log(formData);
		
		var headers = new Headers();
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);

		this.loader=true;
		var res = this.http.post(this.url, formData, { headers: headers })
			.subscribe(data =>{ 
			this.loader=false;
				this.dataJson = data;
				// console.log(data);
				let json = JSON.parse(data['_body']);
			 	// this.router.navigateByUrl('/mass-search-customers');
				var message=json.responseStatusMessage;
					// this.matSnackBar.open(message, 'Close', {
	    //   			duration: 10000,
    	// 		});
				this.utils.notify(message);

		        this.inputFile.nativeElement.value = "";
		        this.fileInpBox.nativeElement.value = "";
		        this.uploadFile = '';
				//if (json['responseStatusFlag'] )
			 },
			 
		error => {
			this.loader=false;
			this.utils.notify('Something went wrong!! Please try after some time.');
		});
		} else {
			this.utils.notify('Please choose a file to upload!!');
			}
	}
	 goToURL(url){
		this.router.navigateByUrl(url);
		}
}



// WEBPACK FOOTER //
// ./src/app/mass-search-customers/template-upload/template-upload.component.ts